const DefaultParameters = {
  bandwidthCriticalThreshold: 70000,
  bandwidthFairThreshold: 0,
  packetLossCriticalThreshold: 0.15,
  packetLossCriticalThresholdMediumBw: 0.2,
  criticalCongestionPeriod: 16000,
};

export default DefaultParameters;
